"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const transformToken = (name, token) => [
    {
        name,
        tokenType: "duration",
        type: "variable",
        value: `${token.ms}ms`,
    },
];
exports.default = transformToken;
